import {Constants} from "../constants";
import {OrderHistoryComponent} from "./order-history/order-history.component";
import {OrderHistoryDetailsComponent} from "./order-history-details/order-history-details.component";
import {Routes} from "@angular/router";

export const ORDER_HISTORY_ROUTES: Routes = [
    {
        // query params for this path: {clear: boolean}
        path: Constants.ORDER_HISTORY_STATE,
        component: OrderHistoryComponent,
        data: {
            roles: [Constants.ROLES.ASSOCIATE, Constants.ROLES.PC, Constants.ROLES.EMPLOYEE, Constants.ROLES.AFFILIATE]
        }
    },
    {
        path: Constants.ORDER_HISTORY_DETAILS_STATE + '/:orderId',
        component: OrderHistoryDetailsComponent,
        data: {
            roles: [Constants.ROLES.ASSOCIATE, Constants.ROLES.PC, Constants.ROLES.EMPLOYEE, Constants.ROLES.AFFILIATE]
        }
    }
];
